var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content queryJob" },
    [
      _c(
        "search-item",
        {
          key: _vm.identify,
          ref: _vm.identify,
          attrs: {
            "is-simple-query": _vm.isSimpleQuery,
            "auto-init": false,
            "show-more-scheme": false,
            "show-simple": false,
            "expand-adv": true,
            reset: "",
            "custom-search-items": _vm.customSearchItems,
            "search-item-code": _vm.$t("CargoMsg.Cargo_FinancialAudit"),
            "custom-sim-query-placeholder": _vm.$t(
              "Clearing.QuickSearchBusinessNumber"
            ),
            "config-module": _vm.configModule,
            "col-settings": _vm.colSettings
          },
          on: {
            "update:isSimpleQuery": function($event) {
              _vm.isSimpleQuery = $event
            },
            "update:is-simple-query": function($event) {
              _vm.isSimpleQuery = $event
            },
            query: _vm.queryHandler,
            advToggle: _vm.scrollCallback
          }
        },
        [
          _c("template", { slot: "operations" }, [_vm._t("operations")], 2),
          _c(
            "template",
            { slot: "searchAreaHeader" },
            [_vm._t("searchAreaHeader")],
            2
          )
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%" },
            attrs: {
              "config-module": _vm.gridConfigModule,
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "check-main-record": false,
              "deselect-main-record": false,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData,
              "min-height": _vm.hasVoucher === 0 ? "350px" : "200px"
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              girdReady: _vm.onGridReady
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "pagination-wrapper",
          attrs: { id: "footer-wrapper-tab-job" }
        },
        [
          _c(
            "div",
            {
              staticClass: "total-wrapper",
              class: [_vm.shouldFixed ? "fixedBottom" : ""]
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showSelectionCount,
                      expression: "showSelectionCount"
                    }
                  ]
                },
                [_vm._v(" " + _vm._s(_vm.selectionCountLabel) + " ")]
              ),
              _vm.reCalc
                ? _c("charge-currency-total-group", {
                    key: 1,
                    attrs: {
                      "amount-to-currency": _vm.localCurrency,
                      mode: "simple",
                      "data-field": _vm.fieldIncome,
                      type: "both",
                      "data-provider":
                        _vm.financeManageHP.totalGroupIncome.dataProvider,
                      "currency-field": "currency",
                      "amount-to-currency-label":
                        _vm.amountToCurrencyLabelIncome
                    }
                  })
                : _vm._e(),
              _vm.reCalc
                ? _c("charge-currency-total-group", {
                    key: 2,
                    attrs: {
                      "amount-to-currency": _vm.localCurrency,
                      mode: "simple",
                      "data-field": _vm.fieldCost,
                      type: "both",
                      "data-provider":
                        _vm.financeManageHP.totalGroupCost.dataProvider,
                      "currency-field": "currency",
                      "amount-to-currency-label": _vm.amountToCurrencyLabelCost
                    }
                  })
                : _vm._e(),
              _vm.reCalc && _vm.showTotalGroup
                ? _c("charge-currency-total-group", {
                    key: 3,
                    attrs: {
                      "amount-to-currency": _vm.localCurrency,
                      mode: "simple",
                      "data-field": "realProfit",
                      type: "both",
                      "data-provider":
                        _vm.financeManageHP.totalGroup.dataProvider,
                      "currency-field": "currency",
                      "amount-to-currency-label": _vm.$t(
                        "CargoMsg.Cargo_Profit"
                      )
                    }
                  })
                : _vm._e(),
              _vm.reCalc &&
              _vm.showTotalGroup &&
              !["VoucherList"].includes(_vm.viewSource)
                ? _c("charge-count-group", {
                    attrs: {
                      "data-provider":
                        _vm.financeManageHP.chargeCountGroup.dataProvider,
                      "basic-currency": _vm.localCurrency,
                      "new-by-job": 3,
                      "show-rmb": true,
                      "always-show": false
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("cargo-pagination", {
            attrs: {
              "config-module": _vm.gridConfigModule,
              total: _vm.searchConditions.total,
              "page-count": _vm.searchConditions.pageCount,
              page: _vm.searchConditions.pageNum,
              limit: _vm.searchConditions.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.searchConditions, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.searchConditions, "pageSize", $event)
              },
              pagination: _vm.queryPageHandler
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }